import _ from 'lodash';

export const AnalyticsService = {

	// Class Schedules
	classAnalytics(classData, filters, viewMode, searchType, filtersVisible) {
		let resultItemList = [];
		let filtersList = [];

		// Loop to get the Filters Results and its count
		for (const item of filters.chiclets) {
			let filterKey = item.type;

			if (filterKey !== 'location' && filterKey !== 'instructor' && filterKey !== 'freeOnly') {
				filterKey = 'tags:' + filterKey;
			} else if (filterKey === 'location') {
				filterKey += '.name';
			} else if (filterKey === 'instructor') {
				filterKey = 'leader.name.displayname';
			}

			// We can't facet on 'freeOnly', so we don't have a 'count' to use for 'filterResultCount', but all results are free when this filter is selected, so just return the total results.
			if (filterKey === 'freeOnly') {
				filtersList.push({
					'filterValue': item.name,
					'filterResultCount': classData.data.results.length,
					'filterKey': filterKey,
					'filterID': filterKey
				});
			} else {
				let scheduleResult = _.filter(classData.data.filters, function(y) {
					return y.filter === filterKey;
				});
				if (scheduleResult.length > 0) {
					scheduleResult[0].values.forEach(function(element) {
						if (item.name === element.value.split(':')[1]) {
							filtersList.push({
								'filterValue': item.name,
								'filterResultCount': element.count,
								'filterKey': filterKey,
								'filterID': filterKey
							});
						}
					});
				}
			}
		}

		let name = [];
		_.forEach(classData.data.results, function(result) {
			_.forEach(result.dayParts, function(daypart) {
				_.forEach(daypart.startTimes, function(startTime) {
					for (let i=0; i < startTime.activities.length; i++) {
						name.push({
							'name': startTime.activities[i].name,
							'id': startTime.activities[i].id
						});
					}
				});
			});
		});

		let scheduleResult = _.groupBy(name, function(d) {
			return d.name;
		});

		// Get the resultItemlist for classes
		_.forEach(scheduleResult, function(schResult) {
			resultItemList.push({
				'resultItemName': schResult[0].name,
				'resultItemImpressionCount': schResult.length,
				'resultItemID': schResult[0].id
			});
		});

		// Data layer push for Event List Analytics data
		LtFramework.actions.collectAnalytics({
			'event': 'Class Schedule Viewed',
			'schedule': {
				'scheduleResults': {
					'resultsCount': name.length,
					'resultItem': resultItemList,
					'numDays': viewMode === 'week' ? 7 : 1
				},
				'scheduleParams': {
					'searchType': searchType,
					'scheduleType': 'Class',
					'filtersApplied': filtersList,
					'filterState': filtersVisible ? 'shown' : 'hidden',
					'filterCount': filters.chiclets.length
				}
			}
		});
	},

	// Event Details
	eventDetailsAnalytics(eventData) {
		LtFramework.actions.collectAnalytics({
			'event': 'Class Detail Detected',
			'classDetails': [{
				'className': eventData.name,
				'classID': 'CLASS_' + eventData.upc,
				'locationName': eventData.locationName,
				'locationID': eventData.locationId
			}]
		});
	},

	// Event Details - Reservation Started
	reservationStartedAnalytics(eventData) {
		LtFramework.actions.collectAnalytics({
			'event': 'Class Reservation Started',
			'classDetails': [{
				'className': eventData.name,
				'classID': 'CLASS_' + eventData.upc,
				'locationName': eventData.locationName,
				'locationID': eventData.locationId
			}]
		});
	},

	// Registration Component (Confirmation)
	registrationAnalytics(regId, regMode, regName, bookingType, participantId, interests) {
		LtFramework.actions.collectAnalytics({
			'event': 'Registration Completed',
			'registrationDetails': [{
				'registrationType': regMode,
				'registrationID': regId,
				'registrationName': regName,
				'bookingType': bookingType,
				'participantID': participantId,
				'interests': interests
			}]
		});
	},

	// Reservation Canceled
	reservationCanceledAnalytics(eventName, eventUpc, locationName, locationId) {
		LtFramework.actions.collectAnalytics({
			'event': 'Class Reservation Canceled',
			'classDetails': [{
				'className': eventName,
				'classID': 'CLASS_' + eventUpc,
				'locationName': locationName,
				'locationID': locationId
			}]
		});
	}

};
